module.exports = __webpack_public_path__ + "assets/images/error-bg-089abbdd.jpg";